import { z } from '../zod';

export const AdminPageAiStatusResponseValidationSchema = z.object({
  sellerId: z.string(),
  createdWithAi: z.boolean(),
  editedWithAi: z.boolean().meta({
    description:
      'True once an AI editor turn has changed the page. Questions that changed nothing do not count.',
  }),
});

export type AdminPageAiStatusResponse = z.infer<typeof AdminPageAiStatusResponseValidationSchema>;
